import type { FeatureFlags } from '@onevesthq/feature-flags/web';
import type {
  IndexRouteObject,
  NonIndexRouteObject,
  RouteObject,
} from 'react-router';
import type { ROUTE_FLAGS } from '../routeMap';

export type RouteEnabledArg = {
  accessiblePages: Set<string>;
  featureFlags: FeatureFlags<typeof ROUTE_FLAGS>;
};

type RouteEnabled = {
  enabled?: (arg: RouteEnabledArg) => boolean;
};

export type AppRoute =
  | (Omit<IndexRouteObject, 'children'> &
      RouteEnabled & { children?: undefined })
  | (Omit<NonIndexRouteObject, 'children'> &
      RouteEnabled & { children?: AppRoute[] });

export const filterEnabledRoutes = (
  routes: AppRoute[],
  arg: RouteEnabledArg,
): RouteObject[] =>
  routes.flatMap((route): RouteObject[] => {
    if (route.enabled?.(arg) === false) {
      return [];
    }
    if (route.index) {
      const { enabled: _enabled, ...indexRoute } = route;
      return [indexRoute];
    }
    const { enabled: _enabled, children, ...rest } = route;
    if (children == null || children.length === 0) {
      return [rest];
    }
    const enabledChildren = filterEnabledRoutes(children, arg);
    if (enabledChildren.length === 0) {
      return [rest];
    }
    return [{ ...rest, children: enabledChildren }];
  });
